import { useEffect } from "react";
import { useSettings } from "../useSetting";
import { ISetting } from "@/domain/setting.interface";

/**
 * Apply `brandInformation` to the document head:
 * - `document.title` becomes `${title} - ${subtitle}` (or just `${title}` when subtitle is empty)
 * - `<link rel="icon">` href is swapped to `brandInformation.logo`
 *
 * Falls back to the values baked into public/index.html until settings load.
 */
export const useDocumentBrand = () => {
	const { data: settings } = useSettings();
	const { brandInformation } = settings || ({} as ISetting);

	useEffect(() => {
		if (!brandInformation) return;

		const { title, subtitle, logo } = brandInformation;

		if (title) {
			document.title = subtitle ? `${title} - ${subtitle}` : title;
		}

		if (logo) {
			let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
			if (!link) {
				link = document.createElement("link");
				link.rel = "icon";
				document.head.appendChild(link);
			}
			link.href = logo;
		}
	}, [brandInformation]);
};
